/* tslint:disable */

declare var Object: any;
export interface ConfigParameterInterface {
  "id"?: number;
  "key"?: string;
  "value"?: string;
}

export class ConfigParameter implements ConfigParameterInterface {
  "id": number;
  "key": string;
  "value": string;
  constructor(data?: ConfigParameterInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ConfigParameter`.
   */
  public static getModelName() {
    return "ConfigParameter";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ConfigParameter for dynamic purposes.
  **/
  public static factory(data: ConfigParameterInterface): ConfigParameter{
    return new ConfigParameter(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ConfigParameter',
      plural: 'ConfigParameters',
      path: 'ConfigParameters',
      idName: '',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "key": {
          name: 'key',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ConfigParameter.ts